module.exports = __webpack_public_path__ + "img/ImgQuestionPrincipal.0215327c.svg";